import { useQuery } from '@tanstack/react-query'
import { Navigate, Outlet, useParams } from 'react-router'
import SplashScreen from '@/components/layout/SplashScreen'
import { fetchPoolBySlug } from '@/features/pools/api'

/* Resolves :poolSlug to a pool the signed-in user is actually a member of.
   Without this, an RLS denial and a genuinely empty pool render identically —
   a blank board with no explanation. Here it becomes a redirect. */
export default function RequirePool() {
  const { poolSlug } = useParams<{ poolSlug: string }>()

  const { data, isPending, isError } = useQuery({
    queryKey: ['pool', poolSlug],
    queryFn: () => fetchPoolBySlug(poolSlug!),
    enabled: Boolean(poolSlug),
  })

  if (isPending) return <SplashScreen />
  if (isError || !data) return <Navigate to="/pools" replace />

  return <Outlet context={{ pool: data }} />
}
